$(document).ready(function(){
	
	eshopCatalogList.init();
	
	$("#compareAdd").click(function(){
		productId = $(this).attr("productId");
		data = {
				"page": "eshopCatalog",
				"action": "compare",
				"command": "add",
				"id": productId,
				"ajax": 1
		}
		$.post(ROOT, data, function(data){
			$.nmManual("#modalCompareAdd");
		}, "json");
		return false;
	});

	$(".radios-box.sizes input").change(function () {
		var id = $(this).val();
		var title = $(".radios-box.sizes title[for='" + id + "']");

		$("form.basket_insert input[name='variant_id']").val(id);

		$(".article.product-description h2").html(title.text());
		$(".availability-box .item-available").html(title.attr("availability"));
		if (title.attr("availabilitytype") == 1) {
			$(".availability-box .item-available").addClass("onstock");
		} else {
			$(".availability-box .item-available").removeClass("onstock");
		}
		if (title.attr("availabilitytype") == 6) { // vyprodano
			$(".basket_insert").hide();
		} else {
			$(".basket_insert").show();
		}

		var color = title.data('color');
		var size = title.data('size');
		var combination = color + "-" + size;

		if (typeof combinations[combination] != "undefined") {
			window.location.replace(combinations[combination]);
		}
	});


});

eshopCatalogList = {
		
	increase: 3,
	displayed: 21,
	showLimit: 21,
	loaded: 0,
	url: window.location.href,
	postData: {
		page: "eshopCatalog",
		action: "show",
		ajax: 1
	},
	
	init: function(){
		$(".pagination .page").hide();

		$('#catalog-list-load-more').click(function(event){
			event.preventDefault();

			$('#catalog-list-load-more').parents(".pagination").addClass("loading");

			var loadPromise = eshopCatalogList.loadItems();
			loadPromise.done(function(){
				eshopCatalogList.showItems();
				eshopCatalogList.init();
			});
		});

		eshopCatalogList.loaded = $(".product-list .list .item").length; // eshopCatalogList.displayed;
	},
	
	loadItems: function(catCooluri, offset, limit){
		
		var data = eshopCatalogList.postData;
		
		if(typeof offset === 'undefined'){offset = eshopCatalogList.loaded;}
		if(typeof limit === 'undefined'){limit = eshopCatalogList.showLimit;}
		
		data.offset = offset;
		data.limit = limit;
		
		if(typeof catCooluri !== 'undefined'){
			data.cat = catCooluri;
		}
		
		//data.loaded = loaded;
		
		var promise = $.ajax({
		  url: eshopCatalogList.url,
		  type: 'POST',
		  dataType: 'html',
		  data: data,
		});
		promise.done(function (response) {
			var $response = $("<div>");
			$response.html(response);

			$(".product-list .list").append($response.find(".list").html());
			$(".pagination").replaceWith($response.find(".pagination"));
			eshopCatalogList.loaded = eshopCatalogList.loaded + $response.find(".list .item").length;
		});
		return promise;
	},
	
	showItems: function(){
		var setDisplayed = eshopCatalogList.displayed + eshopCatalogList.showLimit;
		
		$(".product-list .list .item:nth-child(n+"+(eshopCatalogList.displayed + 1)+"):nth-child(-n+"+(setDisplayed)+")").css({"opacity": 0}).addClass("opened").slideDown(1000);
		eshopCatalogList.slideDown(setDisplayed, eshopCatalogList.displayed, eshopCatalogList.increase);
		
		eshopCatalogList.displayed = setDisplayed;
		$('#catalog-list-load-more').parents(".pagination").removeClass("loading");
	},
	
	slideDown: function(finalCount, count, increase){
		var setCount = count + increase;
		
		$(".product-list .list .item:nth-child(n+"+count+"):nth-child(-n+"+setCount+")")
		.animate({
		    opacity: 1
		  }, {
			  duration: 500,
			  queue: false
		  })
		.promise().done(function() {
		    if(setCount < finalCount){
		    	eshopCatalogList.slideDown(finalCount, setCount, increase);
		    }
		});
	}
};